import { useEffect } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { FAQS } from '../mock/data';

export default function FAQ() {
  // Inject FAQPage JSON-LD for rich Google snippets
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-faq-schema', 'true');
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FAQS.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => script.remove();
  }, []);

  return (
    <section id="faq" className="py-24 lg:py-32 bg-cream/[0.02]">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="eyebrow justify-center inline-flex">Questions? We&rsquo;ve got answers.</div>
          <h2 className="section-title">Frequently asked.</h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-md border border-white/10 bg-ink-panel px-5 hover:border-gold/50 transition-colors data-[state=open]:border-gold/60"
            >
              <AccordionTrigger className="text-left font-display uppercase text-lg text-cream hover:no-underline hover:text-gold py-5 tracking-tight">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-cream/70 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
